import ApiUtil from '../util/ApiUtil';
import Constants from '../constants/Constants';
import {UpsertQueryParamInUrl} from '../component/util/QueryParamsHelper';
import {CancelTokenSource, AxiosResponse, AxiosRequestConfig} from 'axios';
import {IBaseUser} from '../model/baseUser';

const collabBaseUrl = '/api/v1/invitations';

export interface IInvitationModel {
   data: IInvitationData[];
   meta: IInvitationMeta;
}

export interface IInvitationData {
   invitationId: string;
   resourceId: string;
   resourceType: string;
   metaData: IInvitationMetaData;
   authorizationLevel: string;
   recipient: string;
   recipientType: string;
   creator?: IBaseUser;
}

export enum InvitationType {
   email = 'Email',
   techSmithId = 'TechSmithId'
}

export interface IInvitationMeta {
   Total: number;
}

export interface IInvitationMetaData {
   Name: string;
}

export enum InvitationStatus {
   Pending = 'Pending',
   Accepted = 'Accepted',
   Rejected = 'Rejected',
   Revoked = 'Revoked'
}

const getInvitations = async (includeMetadata: boolean = false, CancellationToken?: CancelTokenSource): Promise<IInvitationModel> => {
   let url = `${collabBaseUrl}`;
   url = UpsertQueryParamInUrl(url, 'includeMetadata', includeMetadata.toString());

   const requestConfig: AxiosRequestConfig = CancellationToken ? {cancelToken: CancellationToken.token} : null;

   const response: AxiosResponse = await ApiUtil.executeGetWithoutCacheAsync(url, [Constants.statusCodes.ok, Constants.statusCodes.notFound], requestConfig);
   return response.data as IInvitationModel;
};

const updateInvitationStatus = async (invitationId: string, newStatus: InvitationStatus, CancellationToken?: CancelTokenSource): Promise<any> => {
   const url = `${collabBaseUrl}/${invitationId}`;

   const requestConfig: AxiosRequestConfig = CancellationToken ? {cancelToken: CancellationToken.token} : null;

   const response: AxiosResponse = await ApiUtil.executePatchAsync(url, [Constants.statusCodes.noContent], [{value: newStatus, path: '/Status', op: 'replace', from: null}], requestConfig);
   return response.data;
};

export default {
   getInvitations,
   updateInvitationStatus
};